import { WSList, WSText } from "@wingspanhq/fe-component-library";

import { AIValidationWidget } from "../../../components/AIValidationWidget";
import { RequirementContextType } from "../../../types";
import {
  SharedFileRequestJobStatus,
  SharedFileRequestJobType
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import { ValidationItemProps } from "../../../components/AIValidationWidget/ValidationItem";
import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { Fragment } from "react";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;

interface Props {
  insuranceCoverage: InsuranceCoverageMonitor;
  context: RequirementContextType;
  isInitialLoading: boolean;
}

export const InsuranceCoverageDetailsWidgetContainer: React.FC<Props> = ({
  insuranceCoverage,
  context,
  isInitialLoading
}) => {
  const insuranceCoverageMonitorSettings = insuranceCoverage.settings;
  if (!insuranceCoverageMonitorSettings) {
    return null;
  }

  const insuranceCoverages = insuranceCoverageMonitorSettings.coverages;
  if (!insuranceCoverages) {
    return null;
  }

  let validationItemsMap: Record<string, ValidationItemProps[]> = {};
  // get pending/completed validation jobs from insurance coverage monitor settings
  const insuranceCoverageJobs = insuranceCoverage.jobs;
  if (insuranceCoverageJobs) {
    insuranceCoverageJobs.forEach(job => {
      const groupKey = job.policyType + "_" + job.sourceType;
      if (!validationItemsMap[groupKey]) {
        validationItemsMap[groupKey] = [];
      }
      validationItemsMap[groupKey].push({
        title: job.title,
        description: job.description,
        type: job.type as SharedFileRequestJobType,
        status: job.status as unknown as SharedFileRequestJobStatus,
        statusReason: job.statusReason || "",
        groupKey: groupKey
      });
    });
  }

  const validationList = Object.values(validationItemsMap).sort((a, b) =>
    a[0].groupKey?.includes("Enrollment") ? -1 : 1
  );

  return (
    <WSList gap="S">
      {/** Show rest of validationItemsMap */}
      {validationList.map((validationItems, index) => {
        const isFirst = !index;

        return (
          <Fragment key={index}>
            {/**Show OR before validation widget */}
            {!isFirst ? (
              <WSText.ParagraphSm color="gray500">OR</WSText.ParagraphSm>
            ) : null}
            <AIValidationWidget
              hideTitle={!isFirst}
              key={index}
              contextType={context}
              validationItems={validationItems}
            />
          </Fragment>
        );
      })}
    </WSList>
  );
};
